import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Image, Loader } from '@codex/basics';

const StyledTabsList = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 0;
  margin: 0;
  
  @media only screen and (max-width: 320px) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;

const DefaultTab = styled.li`
  background: #fff;
  float: left;
  list-style-type: none;
  padding: 7px 6px 0 6px;
  margin-right: 8px;
  border: 2px solid #cccccc;
  border-radius: 3px;
  width: 38px;
  height: 44px;
  max-height: 44px;
  max-height: 44px;
  cursor: pointer;
`;

const StyledTab = styled(DefaultTab)`
  ${(props) => props.activeAttachmentID === props.attachmentID && css`
    border-color: #4855a0;
    padding: 0 6px 7px 6px;
    min-height: 44px;
    &:before {
      position: relative;
      display: flex;
      content: "";
      top: 101%;
      left: 33%;
      width: 0;
      height: 0;
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-bottom: 7px solid #4854a0;
    }
  `}
`;

const AttachmentsListTabs = ({
  attachments, isLoading, activeAttachmentID, switchTab
}) => (
  <StyledTabsList>
    {attachments.map((item, current) =>
      (isLoading ? (
        <DefaultTab key={current} count={item.id} attachmentID={item.id}>
          <Loader
            spin
            size={'large'}
          />
        </DefaultTab>
      ) : (
        <StyledTab
          key={current}
          count={item.id}
          attachmentID={item.id}
          activeAttachmentID={activeAttachmentID}
          onClick={() => switchTab(item.id)}
        >
          <Image
            image={item.imageUrl}
            width={40}
            height={40}
          />
        </StyledTab>
      )))}
  </StyledTabsList>
);

AttachmentsListTabs.propTypes = {
  activeAttachmentID: PropTypes.string,
  isLoading: PropTypes.bool,
  attachments: PropTypes.arrayOf(PropTypes.shape({
    attachmentID: PropTypes.string,
    attachmentImgUrl: PropTypes.string
  })).isRequired,
  switchTab: PropTypes.func
};

AttachmentsListTabs.defaultProps = {
  activeAttachmentID: undefined,
  isLoading: false,
  switchTab: () => {}
};

export default AttachmentsListTabs;
